import { getMetaEventMapEntry } from "./event-map"
import { createConversionId, deriveConversionEventId } from "../conversions"

import type { MetaMappedEvent, MetaTrackParams } from "./types"

export function resolveMetaEventId(event: MetaMappedEvent, params: MetaTrackParams): string | undefined {
  if (params.metaEventId) {
    return params.metaEventId
  }

  const mapEntry = getMetaEventMapEntry(event)
  const conversionId = params.conversionId

  if (conversionId && mapEntry) {
    return deriveConversionEventId({
      surface: params.conversionSurface || "marketplace",
      eventKey: mapEntry.metaEventName,
      conversionId,
    })
  }

  if (mapEntry?.requiresExplicitEventId) {
    return undefined
  }

  return createConversionId()
}
